// extracted by mini-css-extract-plugin
module.exports = {"root":"WebhooksEmptyTable_root__7WJiA","iconWrapper":"WebhooksEmptyTable_iconWrapper__1aX-O"};